export const preCheckForm = (commission) => {
  const errors = {};
  Object.keys(commission).forEach((key) => {
    switch (key) {
      default:
        break;
    }
  });
  return errors;
};

export const initializeForm = (initialC) => {
  if (initialC) {
    return {
      ...initialC,
      RecurringCommissionFrom: initialC.RecurringCommissionFrom,
      RecurringCommissionTo: initialC.RecurringCommissionTo,
    };
  }
  return {
    RecurringCommissionType: "",
    RecurringCommissionFrom: "",
    RecurringCommissionTo: "",
  }; // missing
};

export const RecurringCommissionType = {
  ManagementFee: "Management Fee",
  CustodyFee: "Custody Fee",
  OpeningFee: "Opening Fee",
  NoTradeFee: "No Trade Fee",
  AllInFee: "All In Fee",
};

export const TransactionStatus = {
  Initiated: "Initiated",
  OnValidation: "On Validation",
  Validated: "Validated",
  Rejected: "Rejected",
  Cancelled: "Cancelled",
  Executed: "Executed",
  Reverted: "Reverted",
  Authorizing: "Authorizing",
};
